export default "__VITE_ASSET__B4nrLc9ZkbZFRLy5fRf0IQ__"